import { render, staticRenderFns } from "./TrainingCenter02.vue?vue&type=template&id=2604453d&scoped=true&"
import script from "./TrainingCenter02.vue?vue&type=script&lang=js&"
export * from "./TrainingCenter02.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCenter02.vue?vue&type=style&index=0&id=2604453d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604453d",
  null
  
)

export default component.exports